import { render, staticRenderFns } from "./TermsAndConditionsPt.vue?vue&type=template&id=fc7171de&scoped=true"
import script from "./TermsAndConditionsPt.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsPt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc7171de",
  null
  
)

export default component.exports